import { Project } from "../types";

export const projects: Project[] = [
  {
    name: "Hyperwave",
    website: "https://app.hyperwavefi.xyz/hyperfren/HYPIOLIQUID",
    twitter: "https://x.com/Hyperwavefi",
    hlNative: "Yes",
    category: "DeFi,Vault",
    points: "Yes",
    description:
      "The Hyperliquid DeFi SuperApp featuring hwHLP, the first ever liquid token that accrues yield from the Hyperliquidity Provider vault (HLP). Enables users to profit from market making and liquidations on Hypercore while retaining liquid assets for DeFi activities on HyperEVM and beyond. Incubated by Swell Labs with zero fees for the first 90 days, offering seamless deposits of USDT0 or USDe to receive hwHLP tokens for boosted returns across the ecosystem.",
  },
  {
    name: "HypurrCollective",
    website: "https://www.hypurr.co/",
    twitter: "https://x.com/hypurr_co",
    hlNative: "Yes",
    category: "Ecosystem",
    points: "No",
    description:
      "A vibrant collective of passionate founders, builders, traders, and power users working together to contribute towards Hyperliquid's ecosystem growth. The collective provides ecosystem awareness, advisory services, networking opportunities, and exclusive access to new projects within the Hyperliquid ecosystem.",
  },
  {
    name: "HyperLend",
    website: "https://app.hyperlend.finance/?ref=LENDIT",
    twitter: "https://x.com/hyperlendx",
    hlNative: "Yes",
    category: "DeFi,Lending",
    points: "Yes",
    description:
      "A comprehensive money-market platform that serves as the banking infrastructure for Hyperliquid. Built on Aave V3.0.2 architecture, it combines three distinct pool types including core pools, isolated pools, and P2P pools, enabling efficient lending and borrowing of digital assets with flash loans support.",
  },
  {
    name: "HyperSwap",
    website: "https://app.hyperswap.exchange/#/swap?referral=fren",
    twitter: "https://x.com/HyperSwapX",
    hlNative: "Yes",
    category: "DeFi,AMM",
    points: "Yes",
    description:
      "The first native decentralized exchange on HyperEVM, utilizing both Constant Factor AMM and Dynamic Liquidity Market Making models to optimize capital efficiency. Features dynamic fees, liquidity mining incentives, and serves as the primary trading environment for HyperEVM-based assets.",
  },
  {
    name: "Felix",
    website: "https://usefelix.xyz?ref=479E9812",
    twitter: "https://x.com/felixprotocol",
    hlNative: "Yes",
    category: "DeFi,Stablecoin",
    points: "Yes",
    description:
      "A Hyperliquid-native CDP protocol offering coin margin to power users. Licensed Liquity V2 fork that enables users to borrow against majors (ETH, BTC, HYPE) and mint feUSD, a censorship-resistant stablecoin with sustainable native yield and unique CDP architecture for optimal borrowing rates.",
  },
  {
    name: "Valantis",
    website: "https://app.valantis.xyz/",
    twitter: "https://x.com/ValantisLabs",
    hlNative: "Yes",
    category: "DeFi",
    points: "Not Yet",
    description:
      "A modular protocol for deploying custom decentralized exchanges with specialized pools. Features an open-source, MIT-licensed framework that supports rebase tokens and custom liquidity modules without fragmenting liquidity, enabling any conceivable DEX design through composable architecture.",
  },
  {
    name: "Laminar",
    website: "https://laminar.xyz/swap",
    twitter: "https://x.com/laminar_xyz",
    hlNative: "Yes",
    category: "DeFi,AMM",
    points: "No",
    description:
      "A liquidity engine and aggregator that connects disparate liquidity across both HyperEVM and HyperCore to provide optimally priced swaps. Serves as the liquidity infrastructure that bridges different parts of the Hyperliquid ecosystem for seamless asset exchange.",
  },
  {
    name: "KittenSwap",
    website:
      "https://app.kittenswap.finance/points?referrer=0xb805da01BC721D30E19Ed898c260968A8Fe64e64",
    twitter: "https://x.com/KittenswapHype",
    hlNative: "Yes",
    category: "DeFi,AMM",
    points: "Yes",
    description:
      "A DEX on HyperEVM using a ve(3,3) model similar to Velodrome and Solidly. Supports both stablecoin and volatile token trading pairs, rewards long-term users through fee dividends and governance mechanisms, and recently launched concentrated liquidity pools with enhanced point multiplier rewards.",
  },
  {
    name: "HypurrFi",
    website: "https://app.hypurr.fi/buddies/FE64E64",
    twitter: "https://x.com/HypurrFi",
    hlNative: "Yes",
    category: "DeFi,Lending,Stablecoin",
    points: "Yes",
    description:
      "A leveraged lending marketplace for clean leverage loops on Hyperliquid and issuer of USDXL, a hybrid-backed stablecoin. Enables users to loop into leveraged lending positions for hyperaccelerated yield while maintaining spot positions on HYPE and stHYPE, with protocol profits allocated to U.S. Treasury reserves.",
  },
  {
    name: "Farm Fun",
    website: "https://www.thefarm.fun/",
    twitter: "https://x.com/thefarmdotfun",
    hlNative: "Yes",
    category: "AI",
    points: "No",
    description:
      "A blockchain-based AI agent game featuring fully on-chain autonomous AI creatures. Players can create, train, and interact with AI-generated creatures using generative AI models, participate in battles, and utilize an AI Agent Launchpad for deploying monetizable AI models beyond gaming.",
  },
  {
    name: "Liquid Launch",
    website: "https://liqd.ag/swap",
    twitter: "https://x.com/LiquidLaunchHL",
    hlNative: "Yes",
    category: "Launchpad",
    points: "No",
    description:
      "An ERC20 token fair launch platform and multi-market DEX aggregator on HyperEVM. Provides a comprehensive solution for token launches while aggregating liquidity across multiple decentralized exchanges to ensure optimal trading conditions for newly launched assets.",
  },
  {
    name: "Unit",
    website: "https://hyperunit.xyz/",
    twitter: "https://x.com/hyperunit",
    hlNative: "Yes",
    category: "Infra",
    points: "No",
    description:
      "The decentralized asset tokenization infrastructure built exclusively for Hyperliquid. Enables seamless cross-chain deposits and withdrawals of major cryptocurrencies (BTC, ETH, SOL) through a distributed Guardian Network architecture, facilitating native tokenization of multi-chain assets.",
  },
  {
    name: "Harmonix",
    website: "https://app.harmonix.fi/?ref=XyORuSvA",
    twitter: "https://x.com/harmonixfi",
    hlNative: "No",
    category: "DeFi,AMM,Lending",
    points: "Yes",
    description:
      "A yield optimization platform that reshapes DeFi through sophisticated hedge fund strategies effective in all market conditions. Features automated vaults that generate consistent yield even in bearish markets, precise execution with minimal slippage, and advanced risk management systems.",
  },
  {
    name: "Kinetiq",
    website: "https://kinetiq.xyz/",
    twitter: "https://x.com/kinetiq_xyz",
    hlNative: "Yes",
    category: "DeFi,LST",
    points: "Not Live",
    description:
      "A native liquid staking protocol for Hyperliquid launching kHYPE, the liquid staking token for HYPE. Enables users to stake HYPE without lock-up periods while maintaining liquidity for DeFi activities, addressing the 7-day unbonding period with institutional-grade demand for HYPE exposure.",
  },
  {
    name: "StakedHYPE",
    website: "https://stake.hypurr.co/",
    twitter: "https://x.com/stakedhype",
    hlNative: "Yes",
    category: "DeFi,LST",
    points: "No",
    description:
      "The native Hyperliquid liquid staking platform that represents staked HYPE tokens, allowing users to earn staking rewards without permanently locking assets. Built on Hyperliquid network with unlimited maximum supply to support continuous liquidity and flexible DeFi participation.",
  },
  {
    name: "LoopedHYPE",
    website:
      "https://www.stakingrewards.com/stake-app?input=hyperliquid&best-deal=true&validator=nansen&locked=true",
    twitter: "https://x.com/Looped_HYPE",
    hlNative: "Yes",
    category: "DeFi,LST",
    points: "Yes",
    description:
      "An automated looping protocol that maximizes yield on staked HYPE through intelligent strategy automation. Issues LHYPE as the first Liquid Looping Token (LLT), providing receipt tokens that accrue network rewards from staking plus additional looping rewards via automated strategies.",
  },
  {
    name: "Drip Trade",
    website: "https://drip.trade/",
    twitter: "https://x.com/drip__trade",
    hlNative: "Yes",
    category: "NFT,Infra",
    points: "Badges",
    description:
      "A fully on-chain, non-custodial high-frequency NFT exchange on Hyperliquid designed for rapid transactions targeting over 200,000 TPS. Built by an experienced team, it serves as the leading native NFT marketplace with advanced technologies for enhanced trading performance and user experience.",
  },
  {
    name: "HyBridge",
    website: "https://hybridge.xyz/?refUser=f4c52748/",
    twitter: "https://x.com/HyBridgeHL",
    hlNative: "Yes",
    category: "Infra,Bridge",
    points: "Yes",
    description:
      "A cross-chain bridge solution enabling seamless asset transfers between Hyperliquid and multiple blockchain networks including EVM chains and Solana. Facilitates secure and efficient cross-chain asset movements with native support for USDC transfers across different ecosystems.",
  },
  {
    name: "Hypio",
    website: "https://hypio.baby/",
    twitter: "https://x.com/HypioHL",
    hlNative: "Yes",
    category: "NFT",
    points: "Yes",
    description: "Hy Pio",
  },
  {
    name: "Keiko Finance",
    website: "https://app.keikofinance.com/",
    twitter: "https://x.com/KeikoFinance",
    hlNative: "Yes",
    category: "DeFi,Vault",
    points: "Yes",
    description:
      "A permissionless borrowing protocol with dynamic interest rates and liquidation ratios on the Hyperliquid network. Enables users to create collateralized debt positions (CDP) by depositing supported Hyperliquid assets as collateral to borrow KEI, a stablecoin designed for various financial activities.",
  },
  {
    name: "Perpflow",
    website: "https://perpflow.xyz/",
    twitter: "https://x.com/perpflow",
    hlNative: "No",
    category: "DeFi,Delta Neutral Strategy",
    points: "No",
    description:
      "An automated command center for delta-neutral yield generation on Hyperliquid. Simplifies complex trading strategies through intelligent automation, allowing users to earn consistent funding rate yields while staying protected from market volatility via automated rebalancing and execution.",
  },
  {
    name: "PVP Trade",
    website: "https://pvp.trade/",
    twitter: "https://x.com/pvp_dot_trade",
    hlNative: "Yes",
    category: "TG Bot,SocialFi",
    points: "Yes",
    description:
      "A Telegram-based trading bot enabling users to access Hyperliquid's perpetual futures and spot trading services with approximately 11,000 monthly active users. Features clan systems, real-time trading information sharing, and competitive elements while maintaining access to deep liquidity pools across 150+ trading pairs.",
  },
  {
    name: "Fan Fun",
    website: "https://app.fan.fun/",
    twitter: "https://x.com/fanappX",
    hlNative: "Yes",
    category: "SocialFi",
    points: "No",
    description:
      "A SocialFi platform built on Hyperliquid that enables creators to monetize exclusive content and engage in social trading. Functions as a Friendtech-style application for the Hyperliquid ecosystem, facilitating creator-fan interactions and community-driven trading activities.",
  },
  {
    name: "Neko",
    website: "https://www.neko.fun/#app",
    twitter: "https://x.com/neko_hl",
    hlNative: "Yes",
    category: "DeFAI, AI",
    points: "Not Live",
    description:
      "A DeFAI gateway to Hyperliquid featuring AI-powered trading tools and interfaces. Represents the intersection of artificial intelligence and decentralized finance, providing users with intelligent trading assistance and automated strategies within the Hyperliquid ecosystem.",
  },
  {
    name: "Resolv",
    website: "https://app.resolv.xyz/ref/hypereco",
    twitter: "https://x.com/ResolvLabs",
    hlNative: "No",
    category: "Stablecoin",
    points: "Yes",
    description:
      "A revolutionary protocol that maintains USR, the world's first delta-neutral stablecoin natively backed by Ethereum (ETH) and Bitcoin (BTC). Achieves 1:1 capital efficiency through sophisticated perpetual futures hedging mechanisms while eliminating fiat dependency and maintaining dollar peg stability.",
  },
  {
    name: "Liminal",
    website: "https://liminal.money/",
    twitter: "https://x.com/liminalmoney",
    hlNative: "Yes",
    category: "Delta Neutral Strategy",
    points: "No",
    description:
      "A delta-neutral yield protocol built on Hyperliquid Layer 1 that enables users to earn sustainable, real yield without exposure to market fluctuations. Features automated execution, continuous rebalancing, and liquidation protection through sophisticated perpetual funding rate strategies.",
  },
  {
    name: "HL Names",
    website: "https://app.hlnames.xyz/",
    twitter: "https://x.com/hlnames",
    hlNative: "Yes",
    category: "Infra",
    points: "No",
    description:
      "A protocol built on HyperEVM that enables users to create, trade, and manage human-readable names (.hl domains) that map directly to cryptocurrency addresses. Functions as a decentralized and trustless naming system that makes cryptocurrency transactions more user-friendly and reduces errors.",
  },
  {
    name: "HyperDrive",
    website: "https://app.hyperdrive.fi?ref=1FDD49C0",
    twitter: "https://x.com/hyperdrivedefi",
    hlNative: "Yes",
    category: "Lending,DeFi,HLP",
    points: "Yes",
    description:
      "Hyperliquid's comprehensive Yield Hub offering lending & borrowing, liquid HLP, HYPE LST, and one-click yield strategies. Enables HLP holders to unlock additional liquidity by using HLP as collateral while maintaining exposure, and supports HLP loops for scaling exposure with advanced risk management.",
  },
  {
    name: "RedStone",
    website: "https://www.redstone.finance/",
    twitter: "https://x.com/redstone_defi",
    hlNative: "No",
    category: "Infra",
    points: "No",
    description:
      "The modular blockchain oracle providing cutting-edge data solutions with advanced validation mechanisms including EigenLayer integration. Features modular design separating data acquisition from on-chain verification, supporting 1250+ assets across 70+ blockchains with custom data feeds and cross-chain compatibility.",
  },
  {
    name: "DeBridge",
    website: "https://app.debridge.finance/",
    twitter: "https://x.com/deBridgeFinance",
    hlNative: "No",
    category: "Bridge,Infra",
    points: "Yes",
    description:
      "A cutting-edge decentralized cross-chain interoperability protocol that enables secure and efficient asset transfers and data communication between various blockchain networks. Facilitates trustless communication between different dApps and lays the foundation for next-generation DeFi and Web3 applications.",
  },
  {
    name: "HypurrDash",
    website: "https://hyperdash.info/",
    twitter: "https://x.com/hypurrdash",
    hlNative: "Yes",
    category: "Analytics,DeFi",
    points: "No",
    description:
      "A Hyperliquid trader explorer and analytics platform that makes onchain data actionable. Provides comprehensive insights into trading activities, performance metrics, and market analytics, helping users understand and analyze trading patterns within the Hyperliquid ecosystem.",
  },
  {
    name: "Timeswap",
    website: "https://timeswap.io/",
    twitter: "https://x.com/TimeswapLabs",
    hlNative: "No",
    category: "Lending,DeFi",
    points: "No",
    description:
      "A lending and borrowing protocol that functions like Uniswap but for time-based financial instruments. Introduces a new paradigm for lending protocols using AMM-based mechanisms for interest rate discovery and flexible lending/borrowing terms without traditional collateralization requirements.",
  },
  {
    name: "Hyperstable",
    website: "https://app.hyperstable.xyz/r/hypereco",
    twitter: "https://x.com/HyperstableX",
    hlNative: "Yes",
    category: "DeFi,Stablecoin",
    points: "No",
    description:
      "A hyperefficient stablecoin engine built on Hyperliquid that issues USH, a crypto-backed, over-collateralized, and decentralized stablecoin. Features a CDP module for minting USH against collateral, farming opportunities to earn PEG tokens, and a governance module where all protocol revenue is distributed to PEG lockers. Includes minting and referral bonus incentives to promote growth and user acquisition.",
  },
  {
    name: "HyperEVM Sniper Bot",
    website: "https://t.me/HyperEVMSniperBot?start=6ZPBT2",
    twitter: "https://x.com/suite_token",
    hlNative: "Yes",
    category: "TG Bot",
    points: "Yes",
    description:
      "An advanced Telegram-based sniper bot for HyperEVM token launches, offering automated trading capabilities with wallet management, limit orders, DCA strategies, and liquidity sniping. Features multi-wallet creation (up to 10), configurable auto-buy settings, slippage control, gas price optimization, wallet copytrading, and automatic take-profit/stop-loss functionality. Supports various launch platforms and provides self-custodial trading through an intuitive Telegram interface.",
  },
  {
    name: "Supurr",
    website: "https://trade.supurr.app/#/ref/hypereco/",
    twitter: "https://x.com/supurr_app",
    hlNative: "Yes",
    category: "DeFi,Options",
    points: "No",
    description:
      "A short-dated options trading platform built on Hyperliquid offering sophisticated derivatives products. Provides users with options trading capabilities within the Hyperliquid ecosystem, enabling advanced trading strategies and risk management through decentralized options markets.",
  },
  {
    name: "Silhouette",
    website: "https://silhouette.exchange/",
    twitter: "https://x.com/silhouette_ex",
    hlNative: "Yes",
    category: "Privacy,Infra",
    points: "Not Live",
    description:
      "A privacy infrastructure solution designed to obfuscate trading activities on Hyperliquid. Provides enhanced anonymity and privacy features for users who want to maintain confidentiality in their trading activities while operating within the transparent blockchain environment.",
  },
  {
    name: "Okto",
    website: "https://okto.tech/",
    twitter: "https://x.com/okto_web3",
    hlNative: "No",
    category: "DeFi",
    points: "Yes",
    description:
      "The leading self-custody Web3 trading wallet for everything Hyperliquid. Features 1-click cross-chain swaps across EVM, Solana, and Aptos, gas-free transactions, DeFi futures with 50x leverage powered by Hyperliquid, and native access to 100+ token pairs including pre-launch tokens. Offers passive income opportunities with 50%+ APYs across 15+ chains and 17+ protocols, with advanced security including MPC technology and multi-factor authentication.",
  },
  {
    name: "Hyperdelta",
    website: "https://hyperdelta.com/",
    twitter: "https://x.com/HyperdeltaX",
    hlNative: "Yes",
    category: "Options,DeFi",
    points: "Not Live",
    description:
      "An upcoming on-chain options trading platform building the next evolution in decentralized options for the Hyperliquid ecosystem. Focused on bringing sophisticated options trading capabilities to Hyperliquid users with advanced derivatives products and institutional-grade options infrastructure.",
  },
  {
    name: "Slate",
    website: "https://slate.ceo/",
    twitter: "https://x.com/slate_ceo",
    hlNative: "No",
    category: "AI,TG Bot",
    points: "No",
    description:
      "An AI-powered analytics platform that detects market movements before they happen, offering predictive trading intelligence tools. Features include IPA, GPA, Kolscan Confluence for comprehensive market analysis, Top Telegram Traders & Groups tracking, and HL Wallet Tracker specifically for Hyperliquid ecosystem monitoring. Backed by leading VCs including Blockchain Capital, Reforge, and Shima Capital.",
  },
  {
    name: "PurrSwap",
    website: "https://purrswap.finance/",
    twitter: "https://x.com/PurrSwap_",
    hlNative: "Yes",
    category: "DeFi,Lending",
    points: "Not Live",
    description:
      "A next-generation DEX built on HyperEVM powered by battle-tested MIMSwap technology from Abracadabra DAO. Features two pool types - Standard (Uniswap V2 style) and Pegged (concentrated liquidity) - optimized for high-efficiency stablecoin swaps with dramatically reduced slippage. Governed by SPELL token with PurrPoints rewards system, targeting both stable pairs and volatile assets to serve as the liquidity backbone for the Hyperliquid ecosystem.",
  },
  {
    name: "Cluster",
    website: "https://clusterfi.io/",
    twitter: "https://x.com/clusterfi",
    hlNative: "No",
    category: "DeFi,Lending",
    points: "Not Live",
    description:
      "Omnichain money market powered by LayerZero, enabling seamless access to cross-chain LSD liquidity across Ethereum, Solana, and Hyperliquid. Features cross-chain loans with up to 95% LTV, liquidity vaults with 4x leverage capabilities, treasury swaps with CLR token, and non-custodial lending/borrowing of LSDs and stablecoins. Offers zero hidden fees asset acquisition with optimal routing and boosted rewards for liquidity providers.",
  },
  {
    name: "D2",
    website: "https://d2.finance/",
    twitter: "https://x.com/d2_finance",
    hlNative: "Yes",
    category: "DeFi",
    points: "No",
    description:
      "An institutional-grade yield platform delivering high-yield stablecoin, Bitcoin, and RWA strategies on Hyperliquid with over $10M TVL. Combines 2+ years of DeFi-native alpha with 5 years of TradFi experience, offering delta-neutral funding arbitrage, BTC convex upside strategies, and compliant RWA tokenization. Features +140% cumulative returns since Dec 2023, fully on-chain performance tracking, and one-click access to diversified derivative strategies powered by Hyperliquid's deep liquidity.",
  },
  {
    name: "HyperYield",
    website: "https://app.hyperyield.com/markets/",
    twitter: "https://x.com/HyperYieldx",
    hlNative: "Yes",
    category: "DeFi,Lending",
    points: "Yes",
    description:
      "A DeFi lending and borrowing protocol built natively on Hyperliquid, offering users opportunities to earn yield through lending markets and borrow against collateral. Features point-based incentives for platform usage and participation in the growing Hyperliquid DeFi ecosystem.",
  },
  {
    name: "ChainPro",
    website: "https://chainpro.xyz/#hyperliquid",
    twitter: "https://x.com/chainpro_xyz",
    hlNative: "No",
    category: "DeFi,Trading",
    points: "Yes",
    description:
      "A comprehensive DeFi analytics and trading platform built on Hyperliquid, offering real-time market data, portfolio tracking, and advanced trading tools. Features include customizable dashboards, performance analytics, and integration with Hyperliquid's deep liquidity pools. Users can earn points through active platform usage and participation in the ecosystem.",
  },
  {
    name: "DeFi.app",
    website: "https://app.defi.app/join/qpFSNf",
    twitter: "https://x.com/defi_app",
    hlNative: "No",
    category: "DeFi,Trading",
    points: "Yes",
    description:
      "A comprehensive DeFi platform offering seamless access to trading, yield farming, and portfolio management tools. Features include cross-chain asset management, real-time market analytics, and automated trading strategies. Users can earn points through active platform usage, trading volume, and participation in ecosystem governance.",
  },
];
